module.exports = __webpack_public_path__ + "img/唐门.68a52605.png";